import React from 'react';
import '../styles/About.css'
import profile from '../assets/profile2.jpg'

function About() {
  return (
    <div className="about-container">
      <div className='about-section'>
        <div className='titleName'>
          <h1>Arulsham Bhasin</h1>
<p>I'm Arulsham Bhasin, a Mechanical Engineering graduate from UIET, Panjab University (2021–2025). My interests are in robots, mechatronics and design. During my time as an undergrad, I was a visiting student at IIT Gandhinagar and IIT Jammu, contributing to projects involving soft robotic grippers, flexible sensors, and mobile robots. I’ve also been part of student teams building various robots, medical devices, and bio-inspired mechanisms.</p>



{/* <p><strong>I build robots.</strong><br></br> */}
{/* Now, what is a robot? Simply put, robots are like any other walking, talking, thinking beings — except they won’t cry if you hit them with a horizontal spinning hammer. Unless you program them to. Or perhaps humans are robots of flesh, blood and bones.</p> */}

{/* <p>A robot isn’t just what it does; it’s also how it does it. The form becomes part of the function, and the machine becomes part of the action. The way a robot moves, senses, or reacts tells you something about its maker, its purpose, and the thoughts that went into its design. In building them, we sometimes in turn build ourselves.</p> */}

<p>A walking robot says something different than a flying one, and a multimodal one tells an entirely different story. I'd like to hear your stories,
you can hear mine here. <a href="https://arulshambhasin.com/project" target="_blank">Projects</a></p>

{/* <p>I’m now actively seeking Graduate programs for Fall 2026 in robotics — particularly ones that don’t mind if a robot occasionally looks like a bird, swims like a fish, or behaves like it’s having a weird day.</p> */}


<p>Feel free to reach out via <a href="https://arulshambhasin.com/contact" target="_blank">Contact</a>.</p>

        </div>
        <div className='profile-pic'>
          <img src={profile} height="500" />
        </div>
      </div>
      <div className='about-section-mobile'>
        <div className='profile-pic'>
          <img src={profile} height="300" />
        </div>
        <div className='titleName'>
<p>I'm Arulsham Bhasin, a Mechanical Engineering graduate from UIET, Panjab University (2021–2025). My interests are in robots, mechatronics and design. During my time as an undergrad, I was a visiting student at IIT Gandhinagar and IIT Jammu, contributing to projects involving soft robotic grippers, flexible sensors, and mobile robots. I’ve also been part of student teams building various robots, medical devices, and bio-inspired mechanisms.</p>

{/* <p><strong>I build robots.</strong><br></br> */}
{/* Now, what is a robot? Simply put, robots are like any other walking, talking, thinking beings — except they won’t cry if you hit them with a horizontal spinning hammer. Unless you program them to. Or perhaps humans are robots of flesh, blood and bones.</p> */}

{/* <p>A robot isn’t just what it does; it’s also how it does it. The form becomes part of the function, and the machine becomes part of the action. The way a robot moves, senses, or reacts tells you something about its maker, its purpose, and the thoughts taht went into its design. In building them, we sometimes in turn build ourselves.</p> */}

<p>A walking robot says something different than a flying one, and a multimodal one tells an entirely different story. I'd like to hear your stories,
you can hear mine here. <a href="https://arulshambhasin.com/project" target="_blank">Projects</a></p>

{/* <p>I’m currently seeking Graduate programs for Fall 2026 in robotics — particularly ones that don’t mind if a robot occasionally looks like a bird, swims like a fish, or behaves like it’s having a weird day.</p> */}


<p>Feel free to reach out via <a href="https://arulshambhasin.com/contact" target="_blank">Contact</a>.</p>

        </div>
      </div>

      {/* Yaha se Latest Post Change kijiyega */}

      {/* <div className="latest-post">
        <h2>Latest Posts</h2>
        <div className='post-table'>
          <p>
           Migrating the website, will add old and new posts soon. </p> */}
          {/* Post 1*/}
          {/* <div id='1' className='posts'>
            <div className="date">
              <b>06 - 06 June</b>
            </div>
            <div className="title">
              <a href="#">Sorting Algorithms with CUDA!</a>
            </div>
          </div>
          <br />
           */}
          {/* Post 2*/}
          {/* <div id='2' className='posts'>
            <div className="date">
              <b>06 - 06 June</b>
            </div>
            <div className="title">
              <a href="#">Sorting Algorithms with CUDA!</a>
            </div>
          </div>
          <br /> */}
          
          {/* Post 3*/}
          {/* <div id='3' className='posts'>
            <div className="date">
              <b>06 - 06 June</b>
            </div>
            <div className="title">
              <a href="#">Sorting Algorithms with CUDA!</a>
            </div>
          </div> */}
        
       </div>
      //  </div>
    //</div>
  );
}

export default About;
